<template>
    <div class="checkout-container-bg">
        <div class="checkout-container">
            <div class="checkout-container-close" @click="$emit('close-checkout-iframe')">Close</div>
            
            <iframe 
                :allow="params.allow" 
                :allowpaymentrequest="params.allowpaymentrequest" 
                :class="params.class" 
                :src="params.src"
                :title="params.title" 
            >
            </iframe>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Component, Prop } from "vue-property-decorator";
    import TicketWidgetComponent from '../TicketWidgetComponent';

    @Component({components: {}})

    export default class CheckoutV2Iframe extends TicketWidgetComponent {
        @Prop() public params!: CheckoutV2Params;
    }
</script>
<style scoped>
.checkout-container-bg {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
    cursor: pointer;
    animation: fadeInAnimation ease-in-out 0.25s;
}

.checkout-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    animation: all 0.5s ease-in-out;
    animation: fadeInAnimation ease-in-out 0.25s;
    border-radius: 8px;
}

.checkout-container-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: #fff;
    color: #250816;
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 1.43;
}

.checkout-container iframe {
    border-radius: 8px;
    height: 80vh;
    width: 80vw;
    border: none;
}
</style>
